type CacheKey = 'top-menu';

type CachedData<T> = {
  timestamp: number;
  data: T;
};

export const cache = new Map<CacheKey, CachedData<any>>();
const CACHE_TTL = 60 * 60 * 1000; // 60 minutes cache duration

export async function getCachedData<T>(key: CacheKey, fetcher: () => Promise<T>): Promise<T> {
  const cachedItem = cache.get(key) as CachedData<T> | undefined;

  const timeDifference = cachedItem ? Date.now() - cachedItem.timestamp : 0;

  if (cachedItem && timeDifference < CACHE_TTL) {
    return cachedItem.data;
  }

  const data = await fetcher();
  cache.set(key, { data, timestamp: Date.now() });
  return data;
}
